import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, RotateCcwIcon } from 'lucide-react';
interface SaveBarProps {
  count: number;
  saving: boolean;
  onSave: () => void;
  onDiscard: () => void;
}
export function SaveBar({
  count,
  saving,
  onSave,
  onDiscard
}: SaveBarProps) {
  return <AnimatePresence data-id="element-187" data-mp="1t32j76ytkrpf">
      {count > 0 && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 32
    }} className="fixed inset-x-0 bottom-0 z-40 flex justify-center px-4 pb-5" data-id="element-188" data-mp="1t1zwlb8j5bfb">
          <div className="flex w-full max-w-2xl items-center gap-4 rounded-2xl border border-slate-200 bg-white/95 px-5 py-3 shadow-2xl backdrop-blur" data-id="element-189" data-mp="2buc4selv76xd">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-amber-100 text-sm font-bold text-amber-700" data-id="element-190" data-mp="mg743ccbzh4x">
              {count}
            </span>
            <p className="flex-1 text-sm font-medium text-slate-700" data-id="element-191" data-mp="15mb06r9m9pbd">
              {count === 1 ? '1 unsaved change' : `${count} unsaved changes`}
            </p>
            <button type="button" onClick={onDiscard} disabled={saving} className="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-slate-500 transition-colors hover:bg-slate-100 disabled:opacity-50" data-id="element-192" data-mp="19kqs99kk1nvn">
              <RotateCcwIcon className="h-4 w-4" data-id="element-193" data-mp="1oec96mg3uvyi" />
              Discard
            </button>
            <button type="button" onClick={onSave} disabled={saving} className="inline-flex items-center gap-1.5 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-blue-700 disabled:opacity-70" data-id="element-194" data-mp="1tcx7ggbsr5kb">
              {saving ? <>
                  <motion.span animate={{
              rotate: 360
            }} transition={{
              repeat: Infinity,
              duration: 0.7,
              ease: 'linear'
            }} className="h-4 w-4 rounded-full border-2 border-white/40 border-t-white" data-id="element-195" data-mp="7y9lky3kxp9p" />
                  Saving…
                </> : <>
                  <CheckIcon className="h-4 w-4" data-id="element-196" data-mp="1f9qus31siysn" />
                  Save changes
                </>}
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}